<template>
    <div class="elec_charge_manage">
        <div class="elec_charge_top">
            <div class="elec_charge_item">
                <img src="../../../assets/image/custom/elec_charge_top_icon1.png" />
                <div class="elec_charge_item_cnt">
                    <div class="cnt_number">{{cfdData && cfdData.total}}</div>
                    <div class="cnt_name">{{ $t('evcMonitoring.top1') }}</div>
                </div>
            </div>
            <div class="elec_charge_item">
                <img src="../../../assets/image/custom/elec_charge_top_icon2.png" />
                <div class="elec_charge_item_cnt">
                    <div class="cnt_number">{{cfdData && cfdData.charging_total}}</div>
                    <div class="cnt_name">{{ $t('evcMonitoring.top2') }}</div>
                </div>
            </div>
            <div class="elec_charge_item">
                <img src="../../../assets/image/custom/elec_charge_top_icon3.png" />
                <div class="elec_charge_item_cnt">
                    <div class="cnt_number">{{cfdData && cfdData.not_charging_total}}</div>
                    <div class="cnt_name">{{ $t('evcMonitoring.top3') }}</div>
                </div>
            </div>
            <div class="elec_charge_item">
                <img src="../../../assets/image/custom/elec_charge_top_icon4.png" />
                <div class="elec_charge_item_cnt">
                    <div class="cnt_number">{{cfdData && cfdData.lixian_total}}</div>
                    <div class="cnt_name">{{ $t('evcMonitoring.top4') }}</div>
                </div>
            </div>
            <div class="elec_charge_item">
                <img src="../../../assets/image/custom/elec_charge_top_icon5.png" />
                <div class="elec_charge_item_cnt">
                    <div class="cnt_number">{{cfdData && cfdData.guzhang_total}}</div>
                    <div class="cnt_name">{{ $t('evcMonitoring.top5') }}</div>
                </div>
            </div>
        </div>
        <div class="elec_charge_title">
            <div class="elec_title">{{ $t('evcMonitoring.title') }}</div>
            <!-- <div class="battery_search_btn">
                <el-form
                    :model="searchForm"
                    class="leader-style-form"
                    style="padding: 0 40px;"
                    label-width="80"
                    :inline="true"
                >
                    <el-form-item label="充电桩编号">
                        <el-input v-model="searchForm.point_name" maxlength="20" clearable></el-input>
                    </el-form-item>
                    <el-form-item style="float: right">
                        <el-button @click="getCharge()">查询</el-button>
                    </el-form-item>
                </el-form>
            </div> -->
        </div>
        <div class="elec_charge_bottom">
            <el-scrollbar style="width: 100%;height: 100%">
                <div class="elec_charge_bottom_item" v-for="(item, index) in data" :key="index">
                    <div :class="[item.online_type == 1 ? 'bottom_item_title green' : (item.online_type == 2 ? 'bottom_item_title white' : 'bottom_item_title red')]">
                        <div>{{ $t('evcMonitoring.no') }}{{item.point_name}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{item.xinghao}}</div>
                        <div v-if="item.online_type == 2">{{ $t('evcMonitoring.offline') }}</div>
                        <div v-else>{{ $t('evcMonitoring.online') }}</div>
                    </div>
                    <img v-if="item.online_type == 1" src="../../../assets/image/custom/elec_charge_online.png" style="width:100%;height: auto;" />
                    <img v-if="item.online_type == 2" src="../../../assets/image/custom/elec_charge_offline.png" style="width:100%;height: auto;" />
                    <img v-if="item.online_type == 3" src="../../../assets/image/custom/elec_charge_fault.png" style="width:100%;height: auto;" />
                    <div class="bottom_item_cnt">
                        <div style="width: 50%;height: 100%;display: inline-flex;align-items: flex-end;justify-content: center;">
                            <template v-if="item.car_type == 1">
                                <img v-if="item.online_type == 1" src="../../../assets/image/custom/car_white.png" class="bottom_car" />
                                <img v-else-if="item.online_type == 2" src="../../../assets/image/custom/car_white.png" class="bottom_car offline" />
                                <img v-else-if="item.online_type == 3" src="../../../assets/image/custom/car_red.png" class="bottom_car" />
                                <img src="../../../assets/image/custom/car_big.png" class="bottom_car_big" />
                            </template>
                            <template v-if="item.car_type == 2">
                                <img v-if="item.online_type == 1" src="../../../assets/image/custom/car_white.png" class="bottom_car" />
                                <img v-else-if="item.online_type == 2" src="../../../assets/image/custom/car_white.png" class="bottom_car offline" />
                                <img v-else-if="item.online_type == 3" src="../../../assets/image/custom/car_red.png" class="bottom_car" />
                                <img v-if="item.online_type == 1" src="../../../assets/image/custom/car_middle_white.png" class="bottom_middle" />
                                <img v-if="item.online_type == 2" src="../../../assets/image/custom/car_middle_white.png" class="bottom_middle offline" />
                                <img v-if="item.online_type == 3" src="../../../assets/image/custom/car_middle_red.png" class="bottom_middle" />
                            </template>
                            <template v-if="item.car_type == 3">
                                <img v-if="item.online_type == 1" src="../../../assets/image/custom/littlecar_white.png" class="bottom_littlecar" />
                                <img v-else-if="item.online_type == 2" src="../../../assets/image/custom/littlecar_white.png" class="bottom_littlecar offline" />
                                <!-- <img v-else-if="item.online_type == 3" src="../../../assets/image/custom/littlecar_red.png" style="width: 5rem;" /> -->
                                <img v-if="item.online_type == 1" src="../../../assets/image/custom/littlecar_right.png" class="bottom_littlecar_right" />
                                <img v-else-if="item.online_type == 2" src="../../../assets/image/custom/littlecar_right.png" class="bottom_littlecar_right offline" />
                                <!-- <img v-if="item.online_type == 3" src="../../../assets/image/custom/littlecar_red.png" style="width: 5rem;" /> -->
                            </template>
                        </div>
                        <div class="cnt_right">
                            <div class="cnt_right_item">
                                <div>{{ $t('evcMonitoring.model') }}</div>
                                <div>{{item.model}}</div>
                            </div>
                            <div class="cnt_right_item">
                                <div>{{ $t('evcMonitoring.status') }}</div>
                                <div :class="[item.is_warn == '0' ? 'txt_ora' : (item.is_warn == '1' ? 'txt_blue' : (item.is_warn == '2' ? 'txt_grey' : 'txt_red'))]">{{item.is_warn_name}}</div>
                            </div>
                            <div class="cnt_right_item">
                                <div>{{ $t('evcMonitoring.price') }}</div>
                                <div>{{ item.price ? $t('evcMonitoring.yuan') : '' }}&nbsp;{{item.price}}</div>
                            </div>
                            <div class="cnt_right_item">
                                <div>{{ $t('evcMonitoring.shishi') }}</div>
                                <div>{{item.warn_val}}&nbsp;{{item.warn_val ? 'A' : ''}}</div>
                            </div>
                            <div class="cnt_right_item">
                                <div>{{ $t('evcMonitoring.leiji') }}</div>
                                <div>{{item.p}}&nbsp;{{item.p ? 'kW' : ''}}</div>
                            </div>
                            <div class="cnt_right_item">
                                <div>{{ $t('evcMonitoring.money') }}</div>
                                <div>{{ item.total_price ? $t('evcMonitoring.yuan') : '' }}&nbsp;{{item.total_price}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-scrollbar>
        </div>
    </div>
</template>

<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/chart/pie";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/graphic";
import * as api from "@/http/api.js";
import { getCharge } from "@/http/http-60.js";

export default {
    data() {
        return {
            searchForm: {
                point_name: ''
            },
            cfdData: {},
            data: [
                {
                    point_id: '1723951288003317760',
                    online_type: 1, //1在线 2离线 3故障
                    point_name: '',
                    car_type: 2,//1大  2中 3小
                    is_warn: '',
                    is_warn_name: '',
                    model: 'GB/T',
                    price: '',
                    warn_val: '',
                    active_power: '',
                    total_price: '',
                    xinghao: 'GEL-M 60KW'
                },
                {
                    point_id: '1727507941629804544',
                    online_type: 1, //1在线 2离线 3故障
                    point_name: '',
                    car_type: 2,//1大  2中 3小
                    is_warn: '',
                    is_warn_name: '',
                    model: 'GB/T',
                    price: '',
                    warn_val: '',
                    active_power: '',
                    total_price: '',
                    xinghao: 'GEL-M 60KW'
                },
                {
                    online_type: 2, //1在线 2离线 3故障
                    point_name: '003',
                    car_type: 2,//1大  2中 3小
                    is_warn: '2',
                    is_warn_name: '',
                    model: 'GB/T',
                    price: '',
                    warn_val: '',
                    active_power: '',
                    total_price: '',
                    xinghao: 'GEL-M 60KW'
                },
                {
                    online_type: 3, //1在线 2离线 3故障
                    point_name: '004',
                    car_type: 2,//1大  2中 3小
                    is_warn: '3',
                    is_warn_name: '故障',
                    model: 'GB/T',
                    price: '',
                    warn_val: '',
                    active_power: '',
                    total_price: '',
                    xinghao: 'GEL-M 60KW'
                },
                {
                    online_type: 2, //1在线 2离线 3故障
                    point_name: '005',
                    car_type: 2,//1大  2中 3小
                    is_warn: '2',
                    is_warn_name: '',
                    model: 'GB/T',
                    price: '',
                    warn_val: '',
                    active_power: '',
                    total_price: '',
                    xinghao: 'GEL-M 60KW'
                },
                {
                    online_type: 2, //1在线 2离线 3故障
                    point_name: '006',
                    car_type: 2,//1大  2中 3小
                    is_warn: '2',
                    is_warn_name: '',
                    model: 'GB/T',
                    price: '',
                    warn_val: '',
                    active_power: '',
                    total_price: '',
                    xinghao: 'GEL-M 60KW'
                },
                {
                    online_type: 2, //1在线 2离线 3故障
                    point_name: '007',
                    car_type: 2,//1大  2中 3小
                    is_warn: '2',
                    is_warn_name: '',
                    model: 'GB/T',
                    price: '',
                    warn_val: '',
                    active_power: '',
                    total_price: '',
                    xinghao: 'GEL-M 60KW'
                },
                {
                    online_type: 2, //1在线 2离线 3故障
                    point_name: '008',
                    car_type: 2,//1大  2中 3小
                    is_warn: '2',
                    is_warn_name: '',
                    model: 'GB/T',
                    price: '',
                    warn_val: '',
                    active_power: '',
                    total_price: '',
                    xinghao: 'GEL-M 60KW'
                },
                {
                    online_type: 2, //1在线 2离线 3故障
                    point_name: '009',
                    car_type: 2,//1大  2中 3小
                    is_warn: '2',
                    is_warn_name: '',
                    model: 'GB/T',
                    price: '',
                    warn_val: '',
                    active_power: '',
                    total_price: '',
                    xinghao: 'GEL-M 60KW'
                },
                {
                    online_type: 2, //1在线 2离线 3故障
                    point_name: '010',
                    car_type: 2,//1大  2中 3小
                    is_warn: '2',
                    is_warn_name: '',
                    model: 'GB/T',
                    price: '',
                    warn_val: '',
                    active_power: '',
                    total_price: '',
                    xinghao: 'GEL-M 60KW'
                },
            ],
            timer: null,
        };
    },
    mounted() {
        this.getCharge();
        this.setTimer();
    },
    methods: {
        setTimer() {
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(() => {
                this.getCharge();
            }, 5000);
        },
        getCharge() {
            getCharge({...this.searchForm}).then(res => {
                if (res && res.error_code == 0) {
                    this.cfdData = res.bus_json;
                    this.data.forEach(data => {
                        if(data.point_id) {
                            const realData = res.bus_json.data[data.point_id];
                            data.point_name = realData.point_name;
                            data.is_warn = realData.is_warn;
                            if(realData.is_warn == 0) {
                                data.is_warn_name = this.$t('evcMonitoring.weichongdian');
                            } else if(realData.is_warn == 1) {
                                data.is_warn_name = this.$t('evcMonitoring.chongdianzhong');
                            } else if(realData.is_warn == 2) {
                                data.is_warn_name = this.$t('evcMonitoring.lixian');
                            } else if(realData.is_warn == 3) {
                                data.is_warn_name = this.$t('evcMonitoring.guzhang');
                            }
                            data.price = realData.price;
                            data.warn_val = realData.warn_val;
                            data.active_power = realData.active_power;
                            data.total_price = realData.total_price;
                        } else {
                            if(data.is_warn == 0) {
                                data.is_warn_name = this.$t('evcMonitoring.weichongdian');
                            } else if(data.is_warn == 1) {
                                data.is_warn_name = this.$t('evcMonitoring.chongdianzhong');
                            } else if(data.is_warn == 2) {
                                data.is_warn_name = this.$t('evcMonitoring.lixian');
                            } else if(data.is_warn == 3) {
                                data.is_warn_name = this.$t('evcMonitoring.guzhang');
                            }
                        }
                    })
                }
            });
        },
    },
    computed: {
        language() {
            return this.$store.state.language.language;
        },
    },
    destroyed() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss">
.elec_charge_manage {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0 3rem;
    position: relative;
    .elec_charge_top {
        width: 100%;
        height: 9rem;
        display: inline-flex;
        align-items: center;
        .elec_charge_item {
            flex: 1;
            height: 100%;
            display: inline-flex;
            align-items: center;
            justify-content: center;
         //   border: 1px solid red;
            img {
                width: 2rem;
                height: auto;
            }
            .elec_charge_item_cnt {
                color: #fff;
                text-align: center;
                margin-left: 1rem;
                .cnt_number {
                    height: 1.5rem;
                    line-height: 1.5rem;
                    font-size: 1.2rem;
                    font-weight: 600;
                }
                .cnt_name {
                    height: 1.5rem;
                    line-height: 1.5rem;
                    font-size: 0.75rem;
                    color: rgba(228, 238, 246, 1);
                }
            }
        }
    }
    .elec_charge_bottom {
        width: 100%;
        height: calc(100% - 11rem);
       // border: 1px solid red;
        display: inline-flex;
        flex-flow: row wrap;
       // align-items: center;
        //justify-content: space-evenly;
        .elec_charge_bottom_item {
            width: 31%;
            margin: 0 1%;
            display: inline-flex;
            align-items: center;
            flex-flow: row;    
            position: relative;    
            .bottom_item_title {
                position: absolute;
                top: 8%;
                left: 13%;
              //  border: 1px solid red;
                width: 87%;
                height: 1.5rem;
                display: inline-flex;
                div {
                    flex: 1;
                    line-height: 1.5rem;
                    height: 1.5rem;
                    font-size: 0.8rem;
                    &:nth-child(2) {
                        text-align: right;
                    }
                }
            } 
            .bottom_item_cnt {
                position: absolute;
                top: 25%;
                left: 0;
                width: 100%;
                height: 75%;
              //  border: 1px solid red;
                display: inline-flex;
                align-items: flex-end;
                flex-flow: row;
                padding: 0.5rem 0;
                box-sizing: border-box;
                .bottom_car {
                    width: 7.5rem;
                    margin-right: 0.5rem;
                }
                .bottom_car_big {
                    width: 4.2rem;
                }
                .bottom_car_middle {
                    width: 3rem;
                }
                .bottom_littlecar {
                    width: 6rem;
                    margin-right: 0.5rem;
                }
                .bottom_littlecar_right {
                    width: 2rem;
                }
                .cnt_right {
                    flex: 1;
                    height: 100%;
               //     border: 1px solid red;
                }
                .cnt_right_item {
                    width: 100%;
                    height: 16.66%;
                    display: inline-flex;
                    align-items: center;
                    font-size: 0.75rem;
                    div {
                        flex: 1;
                        &:first-child {
                            color: rgba(204, 227, 255, 1);
                            text-indent: 1.5em;
                        }
                        &:nth-child(2) {
                            text-align: center;
                            color: #fff;
                        }
                    }
                    
                    &:nth-child(2n) {
                        background-color: rgba(15, 73, 123, 0.3);
                    }
                    &:nth-child(2n+1) {
                        background-color: transparent;
                    }
                }
            }
        }
    }
    .white {
        color: #fff;
    }
    .green {
        color: rgba(34, 147, 87, 1);
    }
    .red {
        color: rgba(255, 204, 208, 1);
    }
    .offline {
        opacity: 0.5;
    }
    .txt_ora {
        color: rgba(233, 116, 72, 1) !important;
    }
    .txt_blue {
        color: rgba(0, 132, 255, 1) !important;
    }
    .txt_red {
        color: rgba(255, 204, 208, 1) !important;
    }
    .txt_grey {
        color: rgba(182, 182, 182, 1);
    }
    .leader-style-form .el-input__inner {
        height: 1.8rem;
    }
    .leader-style-form .el-button {
        height: 1.8rem;
        margin-left: 0 !important;
        border-radius: 0;
        color: #fff;
        border: none;
        background-color: rgba(0, 132, 255, 1);
        padding: 0 0.8rem;
    }
    .leader-style-form .el-form-item__label {
        font-size: 0.8rem;
    }
    .elec_charge_title {
        width: 100%;
        height: 2rem;
        background: url("../../../assets/image/custom/elec_charge_title.png") no-repeat;
        background-size: 100% 100%;
        position: relative;
        .elec_title {
            position: absolute;
            top: 20%;
            left: 4%;
            color: rgba(148, 194, 232, 1);
            font-size: 0.8rem;
        }
        .battery_search_btn {
            position: absolute;
            top: 0;
            right: 0;
            color: rgba(148, 194, 232, 1);
            font-size: 0.8rem;
          //  border: 1px solid red;
            width: 70%;
            height: 1.8rem;
            text-align: right;
        }
    }
}
</style>
